import types from '../action/types'

// user : undefined means not designed
//        null means not login
export default function auth(state = { user: undefined }, action) {
  switch (action.type) {
  case types.GET_CURRENT_USER: {
    return { ...state, user: action.payload };
  }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducer/authReducer.js